import React, { useState } from 'react';

function FoodSmsSettings({ isMobile }) {
    const [smsEnabled, setSmsEnabled] = useState(true);
    const [phoneNumber, setPhoneNumber] = useState('+1 (555) 123-4567');

    return (
        <div style={{
            backgroundColor: '#f9fafb',
            padding: isMobile ? '20px' : '30px',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            marginBottom: '30px'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                marginBottom: '20px'
            }}>
                <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    backgroundColor: '#d1fae5',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#10b981',
                    fontSize: '18px'
                }}>
                    📱
                </div>
                <div>
                    <h3 style={{
                        margin: '0 0 5px 0',
                        fontSize: isMobile ? '16px' : '18px',
                        fontWeight: '600',
                        color: '#1a1a1a'
                    }}>
                        SMS Notifications
                    </h3>
                    <p style={{
                        margin: 0,
                        fontSize: isMobile ? '13px' : '14px',
                        color: '#666'
                    }}>
                        Configure SMS alerts for orders and important updates
                    </p>
                </div>
            </div>

            <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                marginBottom: '15px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '15px' : '0'
                }}>
                    <div>
                        <h4 style={{
                            margin: '0 0 5px 0',
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#374151'
                        }}>
                            Enable SMS Notifications
                        </h4>
                        <p style={{
                            margin: 0,
                            fontSize: '14px',
                            color: '#6b7280'
                        }}>
                            Receive text message alerts for new orders
                        </p>
                    </div>
                    <div style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center'
                    }}>
                        <span style={{
                            fontSize: '14px',
                            color: smsEnabled ? '#10b981' : '#ef4444',
                            fontWeight: '500'
                        }}>
                            {smsEnabled ? 'Enabled' : 'Disabled'}
                        </span>
                        <button
                            onClick={() => setSmsEnabled(!smsEnabled)}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: smsEnabled ? '#ef4444' : '#10b981',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600'
                            }}
                        >
                            {smsEnabled ? 'Disable' : 'Enable'}
                        </button>
                    </div>
                </div>
            </div>

            <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                border: '1px solid #e5e7eb'
            }}>
                <h4 style={{
                    margin: '0 0 15px 0',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#374151'
                }}>
                    Phone Number
                </h4>
                <div style={{
                    display: 'flex',
                    gap: '10px',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: isMobile ? 'stretch' : 'center'
                }}>
                    <input
                        type="text"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        style={{
                            flex: 1,
                            padding: '10px',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            fontSize: '14px'
                        }}
                    />
                    <button
                        onClick={() => alert('Phone number updated')}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#6B46C1',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '600'
                        }}
                    >
                        Update
                    </button>
                </div>
                <p style={{
                    margin: '10px 0 0 0',
                    fontSize: '12px',
                    color: '#9ca3af'
                }}>
                    Enter your phone number with country code
                </p>
            </div>
        </div>
    );
}

export default FoodSmsSettings;